export default __webpack_public_path__ + "static/icon-mision-4592261dd46eaeedcbd91bb0c6c0caa7.png";